import type { AssetCharge } from '../../../../core/models/assets/asset-charges.dto';

/** The linked asset as "code - title", or the empty string when the charge has no asset. */
export function chargeAssetLabel(charge: Pick<AssetCharge, 'assetCode' | 'assetTitleEn' | 'assetTitleAr'>, isArabic: boolean): string {
  const en = charge.assetTitleEn?.trim();
  const ar = charge.assetTitleAr?.trim();
  const title = (isArabic ? ar || en : en || ar) || '';
  return [charge.assetCode, title].filter((part) => !!part).join(' - ');
}
